import { ReactNode } from 'react';
import { css } from '@emotion/react';
import WeavePoweredLogo from '../../assets/powered-by-weave.svg?react';

const styles = {
  legalItems: css`
    display: flex;
    justify-content: center;
  `,
};

export const LogoWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div css={styles.legalItems}>
      <WeavePoweredLogo />
      {children}
    </div>
  );
};
